<template lang="pug">
  .years
    h2 {{ i18n('yearsWithoutEvents') }}
    p {{ yearList.length }} / 100
    .year-list
      .year(v-for="year, number in yearList" :key="number")
        h3 {{ year.year }}
        router-link.tag(
          v-for="key, j in year.keys"
           :class="`element-${key.value}`"
          :to="{ name: 'create-event', params: { event: { year: year.year.toString(), key: key.key } }}"
          :key="j"
          )
          span.slanted.element-background {{ key.title[locale] }}
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'empty-years',
  created() {
    this.listNumbers();
    this.listEvents();
  },
  computed: {
    ...mapGetters('locale', ['i18n']),
    ...mapState('locale', ['locale']),
    ...mapState('events', ['events']),
    ...mapState('weekdays', ['keys', 'numbers', 'colors']),
    yearList() {
      return Object.keys(this.keys.year)
        .map(yearS => {
          const year = parseInt(yearS, 10);
          return {
            year,
            keys: this.numbers
              .filter(d => d.value % 7 === this.keys.year[year])
              .map(d => Object.assign({ color: this.colors[d.value] }, d)),
            hasEvents: !!this.events.filter(d => d.year === year).length
          };
        })
        .filter(d => !d.hasEvents)
    }
  },
  methods: {
    ...mapActions('weekdays', ['listNumbers']),
    ...mapActions('events', ['listEvents'])
  }
}
</script>

<style lang="stylus" scoped>
  .years
    margin 1rem

  .year-list
    display flex
    flex-direction row
    flex-wrap wrap
    .year
      flex 1 1 100%
      box-sizing border-box
      padding 1rem
      margin 0 0 .5rem
      // height 15rem
      overflow hidden
      text-overflow ellipsis
      box-shadow 5px 5px 5px rgba(0, 0, 0, .1)

  .tag
    text-decoration none
    display inline-block
    margin .25rem .5rem
    background transparent

</style>
